'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = require('./Aria');

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage dialog (modal) elements
 *
 * @param {Object} config - Config options for AriaDialog
 * @param {HTMLElement} config.dialog - The dialog element
 * @param {HTMLElement} config.close - The dialog close button; should be the first child of the dialog
 * @param {Object} config.attributes - An Object of aria-* attributes to be added to the `target`, where the key completes an 'aria-' attribute name and the value is a valid attribute value.
 * @param {HTMLElement} config.content - The element wrapping the site content, of which the modal is NOT a child. The modal should be a child of document.body
 *
 * E.g.:
 * const modal = new AriaDialog({
 *   dialog: modalElement,
 *   close: closeElement,
 *   attributes: {
 *     label: 'Modal Title'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   },
 *   content: siteWrapperElement
 * });
 */
var AriaDialog = function (_Aria) {
  _inherits(AriaDialog, _Aria);

  _createClass(AriaDialog, null, [{
    key: 'createOverlayElement',

    /**
     * Create the dialog overlay element.
     */
    value: function createOverlayElement() {
      var overlay = document.createElement('div');
      overlay.id = 'aria-dialog-overlay';
      return overlay;
    }
  }]);

  function AriaDialog(config) {
    _classCallCheck(this, AriaDialog);

    var _this = _possibleConstructorReturn(this, (AriaDialog.__proto__ || Object.getPrototypeOf(AriaDialog)).call(this));

    _this.element = config.dialog;
    _this.closeButton = config.close;
    _this.siteContent = config.content;
    _this.attributes = config.attributes || {};

    _this.targetElement = _this.element;

    _this.overlay = document.getElementById('aria-dialog-overlay');
    if (null === _this.overlay) {
      _this.overlay = _this.constructor.createOverlayElement();
      document.body.insertBefore(_this.overlay, _this.element);
    }

    _this.isShown = false;

    // Bind class methods
    _this.outsideClick = _this.outsideClick.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.keydownTrapTab = _this.keydownTrapTab.bind(_this);
    _this.keydownEsc = _this.keydownEsc.bind(_this);
    _this._hide = _this._hide.bind(_this);
    _this._show = _this._show.bind(_this);
    _this.ariaHide = _this.ariaHide.bind(_this);
    _this.ariaShow = _this.ariaShow.bind(_this);
    _this.ariaToggle = _this.ariaToggle.bind(_this);

    _Aria3.default.eventPolyfill();
    _this.init();
    return _this;
  }

  /**
   * Initial element setup.
   */


  _createClass(AriaDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.element.setAttribute('aria-hidden', 'true');

      Object.keys(this.attributes).forEach(function (attr) {
        _this2.element.setAttribute('aria-' + attr, _this2.attributes[attr]);
      });
    }

    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'outsideClick',
    value: function outsideClick(event) {
      if (this.isShown && !this.element.contains(event.target)) {
        this.ariaHide();
      }
    }

    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (this.isShown) {
        if (event.keyCode === this.tabKey) {
          this.keydownTrapTab(event);
        } else if (event.keyCode === this.escapeKey) {
          this.keydownEsc();
        }
      }
    }

    /**
     * Trap key tabs inside dialog.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keydownTrapTab',
    value: function keydownTrapTab(event) {
      this.collectInteractiveChildren();
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);

      var lastItem = this.interactiveChildElements.length - 1;

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.interactiveChildElements[lastItem].focus();
      } else if (!event.shiftKey && focusedIndex === lastItem) {
        // eslint-disable-line max-len
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }

    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: 'keydownEsc',
    value: function keydownEsc() {
      this.ariaHide();
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaHide',
    value: function ariaHide() {
      _fastdom2.default.mutate(this._hide);
    }

    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: '_hide',
    value: function _hide() {
      this.element.setAttribute('aria-hidden', 'true');
      this.siteContent.setAttribute('aria-hidden', 'false');

      this.isShown = false;

      this.closeButton.removeEventListener('click', this.ariaHide);
      document.body.removeEventListener('keydown', this.keyDownHandler);
      this.overlay.removeEventListener('click', this.outsideClick);

      var hide = null;
      var detail = { expanded: this.isShown };
      hide = _Aria3.default.createAriaEvent('dialoghide', detail);
      this.element.dispatchEvent(hide);

      this.focusEl.focus();
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaShow',
    value: function ariaShow() {
      _fastdom2.default.mutate(this._show);
    }

    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: '_show',
    value: function _show() {
      this.focusEl = document.activeElement;
      this.element.setAttribute('aria-hidden', 'false');
      this.siteContent.setAttribute('aria-hidden', 'true');

      this.isShown = true;

      this.closeButton.addEventListener('click', this.ariaHide);
      document.body.addEventListener('keydown', this.keyDownHandler);
      this.overlay.addEventListener('click', this.outsideClick);

      var show = null;
      var detail = { expanded: this.isShown };
      show = _Aria3.default.createAriaEvent('dialogshow', detail);
      this.element.dispatchEvent(show);

      this.collectInteractiveChildren();
      this.setFocusToFirstItem();
    }

    /**
     * Toggle ARIA attributes.
     */

  }, {
    key: 'ariaToggle',
    value: function ariaToggle() {
      if (this.isShown) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }
  }]);

  return AriaDialog;
}(_Aria3.default);

exports.default = AriaDialog;


//////////////////
// WEBPACK FOOTER
// ./~/js-component-framework/lib/plugins/AriaDialog.js
// module id = ./node_modules/js-component-framework/lib/plugins/AriaDialog.js
// module chunks = 7